import { Alert, AlertIcon, Box, Card, CardBody, Flex, Select, Text, VStack } from "@chakra-ui/react";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Loader from "../../utils/Loader/Loader";
import Layout from "../Layout/Layout";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import { SettingContext } from "../Settings/Reducer/SettingProvider";

export default function AgencyWrapper({ children }) {
  const { state, loading } = useContext(SettingContext);
  const agency = useContext(AgencyContext);
  const { getAgencies, staffRole, allAgencies, agencyData, switchAgency } = agency;

  const { pathname } = useLocation();
  const isAgencyPage = pathname.startsWith("/agency");

  useEffect(() => {
    getAgencies();
  }, []);

  if (loading && agency.loading) return <Loader />;

  const hasAgencyCredit = state?.credits?.agency === 1;
  const isStaff = staffRole != null;

  // ONLY show alert when on /agency AND neither owner nor staff
  const showAlert = isAgencyPage && !hasAgencyCredit && !isStaff;

  return (
    <Layout>
      <VStack h="100%" spacing={2} borderRadius="md">
        {showAlert ? (
          <Card variant="elevated" width="100%" my={12}>
            <CardBody>
              <Alert status="info">
                <AlertIcon />
                Please upgrade to one of the Agency packs to enable this section.
              </Alert>
            </CardBody>
          </Card>
        ) : (
          <Box w="100%" h={"100%"}>
            {allAgencies.length > 1 && (
              <Flex align="center" gap={3} mb={3}>
                <Text fontWeight="semibold" fontSize="sm" whiteSpace="nowrap">
                  Agency:
                </Text>
                <Select
                  size="sm"
                  maxW="280px"
                  value={agencyData?.id || ""}
                  onChange={(e) => switchAgency(e.target.value)}
                >
                  {allAgencies.map((a) => (
                    <option key={a.id} value={a.id}>
                      {a.name || a.id}{a.role !== "owner" ? ` (${a.role})` : ""}
                    </option>
                  ))}
                </Select>
              </Flex>
            )}
            {children}
          </Box>
        )}
      </VStack>
    </Layout>
  );
}
